import { Avatar } from '@cian/ui-kit';

import { type FC } from 'react';

import { useCardOfferPublisherContext } from '@/microfrontends/listing/shared/context/selectors/cardData';
import { getPublisherAvatarType } from '@/microfrontends/listing/shared/utils/publisher';

import { extractUndefined } from '@/packages/utils/extractUndefined';

export const PublisherAvatarContainer: FC = () => {
  const { media, type } = useCardOfferPublisherContext();

  const avatarType = getPublisherAvatarType(extractUndefined(type));

  return <Avatar size={56} src={media.picture} type={avatarType} />;
};
